export const SportTypeEnum = {
  ESport: 0,
  VirtualSport: 1,
  Sport: 2,
  Racing: 4,
  UnknownSport: 5,
};
